module.exports = __webpack_public_path__ + "img/3.50933daa.jpg";